// Core
import React from 'react'

export default function Home() {
    return <div>best time tracker ever! ! !</div>
}
